import CachedIcon from '@mui/icons-material/Cached';
import { Box, Card, CircularProgress, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toPublisherAction } from '../../redux/toolkit/dashbaord/toPublisher';

export default function TotalPublisher() {
    // state
    const dispatch = useDispatch()
    const toPublisherSelector = useSelector(state => state.toPublisher)
    const { data, loading } = toPublisherSelector

    // fn
    const handleRefeash = () => {
        dispatch(toPublisherAction())
    }

    return (
        <Card sx={{ p: 2, color:'#fff' }} >
            <Stack direction='row' justifyContent='space-between' >
                <Typography sx={{ color: '#5E6C8A',fontFamily:'Montserrat'}} variant='subtitle2'>Total Publisher</Typography>
                <IconButton sx={{ color: '#5E6C8A' }} onClick={handleRefeash}><CachedIcon /></IconButton>
            </Stack>

            {
                loading
                    ? <CircularProgress />
                    : <Box>
                        <Typography variant='h3' color='primary' sx={{ fontWeight: 600, color: '#071D45' }}>{data || "--"}</Typography>
                    </Box>
            }
        </Card>
    )
}
